// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3Czyc","header":"Messages_header__e9oi-"};